/**
 * Origem Flow: tour de boas-vindas ancorado no chrome próprio (rail de
 * ícones, busca ⌘K, espaços na sidebar, sininho). Os tours herdados do
 * Baserow apontam para elementos do layout antigo e ficam desligados — só
 * este roda, uma vez por pessoa (saveCompleted).
 */
import {
  GuidedTourStep,
  GuidedTourType,
} from '@baserow/modules/core/guidedTourTypes'

class OrigemStep extends GuidedTourStep {
  constructor(app, key, selectors, position = 'right-top', padding = 4) {
    super(app)
    this.key = key
    this._selectorsList = selectors
    this._position = position
    this._highlightPadding = padding
  }

  get title() {
    return this.app.$i18n.t(`origemTour.${this.key}.title`)
  }

  get content() {
    return this.app.$i18n.t(`origemTour.${this.key}.content`)
  }

  get selectors() {
    return this._selectorsList
  }

  get position() {
    return this._position
  }
}

class OrigemWelcomeStep extends OrigemStep {
  constructor(app) {
    super(app, 'welcome', [], 'center')
  }

  get buttonText() {
    return this.app.$i18n.t('origemTour.welcome.buttonText')
  }

  get skipIfNotFirst() {
    return true
  }
}

export class OrigemWelcomeGuidedTourType extends GuidedTourType {
  static getType() {
    return 'origem-welcome'
  }

  get order() {
    return 10
  }

  get steps() {
    return [
      new OrigemWelcomeStep(this.app),
      new OrigemStep(
        this.app,
        'rail',
        ['[data-highlight="origem-rail"]'],
        'right-top',
        6
      ),
      new OrigemStep(
        this.app,
        'search',
        ['[data-highlight="origem-search"]'],
        'bottom',
        6
      ),
      new OrigemStep(
        this.app,
        'spaces',
        ['[data-highlight="applications"]'],
        'right-top',
        6
      ),
      new OrigemStep(
        this.app,
        'bell',
        ['[data-highlight="origem-bell"]'],
        'bottom',
        6
      ),
    ]
  }

  /**
   * Só na área autenticada com o chrome (página de workspace, tabela, hubs).
   * Páginas sem o rail (login, públicas, mobile /m) não mostram o tour.
   */
  isActive() {
    if (typeof document === 'undefined') {
      return false
    }
    const route = this.app.$store.getters['routeMounted/routeMounted']
    if (!route || !route.name || route.name.startsWith('mobile')) {
      return false
    }
    return !!document.querySelector('[data-highlight="origem-rail"]')
  }
}
